<script setup lang="ts">
import { useOrthancStore } from '../store/dicom-web/orthanc-store';

const orthancStore = useOrthancStore();
</script>

<template>
  <div v-if="orthancStore.statistics" class="stats-bar">
    <div class="stat-item" title="Patients">
      <i class="fa-solid fa-users fa-sm" />
      <span>{{ orthancStore.statistics.CountPatients }}</span>
    </div>
    <div class="stat-item" title="Studies">
      <i class="fa-solid fa-book-medical fa-sm" />
      <span>{{ orthancStore.statistics.CountStudies }}</span>
    </div>
    <div class="stat-item" title="Instances">
      <i class="fa-solid fa-images fa-sm" />
      <span>{{ orthancStore.statistics.CountInstances.toLocaleString() }}</span>
    </div>
    <div class="stat-item" title="Disk usage">
      <i class="fa-solid fa-hard-drive fa-sm" />
      <span>{{ orthancStore.statistics.TotalDiskSizeMB }} MB</span>
    </div>
  </div>
</template>

<style scoped>
.stats-bar {
  display: flex;
  gap: 1rem;
  align-items: center;
  font-size: 0.75rem;
  color: var(--md-text-secondary);
}

.stat-item {
  display: flex;
  align-items: center;
  gap: 0.3rem;
}
</style>
